<mat-form-field [appearance]="appearance"
                [style.width]="width + '%' ">
<!--   <mat-label *ngIf="withLabel" style="text-transform: capitalize">{{name}}</mat-label>-->

   <input matInput
          #input
          #trigAutoComplete="matAutocompleteTrigger"
          [placeholder]="placeholder" aria-label="State"
          [matAutocomplete]="autocomp"
          [formControl]="inputCtrl" >

   <mat-autocomplete #autocomp="matAutocomplete"
                     (select)="select($event)"
                     [panelWidth]="220"
                     (closed)="autocompleteClosed()"
                     (optionSelected)="outputSelection($event)"
                     [displayWith]="displayFn.bind(this, array)">

      <mat-option *ngIf="isLoading" class="is-loading text-center">
         <progress class="ds-progress w-full"></progress>
      </mat-option>

      <ng-container *ngIf="!isLoading && inSearch">
         <mat-option *ngFor="let x of array"
                     [value]="x.data.id" class="multiline-mat-option">
            <ng-container [ngTemplateOutlet]="optionTemplate"
                          [ngTemplateOutletContext]="{$implicit: x}"
            ></ng-container>
         </mat-option>
         <mat-option *ngIf="errorMsg" [value]="">
            <small class="italic whitespace-normal">
               <i class="fal fa-circle-exclamation mr-1"></i>{{errorMsg}}
            </small>
         </mat-option>
         <div *ngIf="showAdd" (click)="clickNew()">
            <button class="ds-btn ds-btn-small ds-btn-info w-full">
               <small>
                  <i class="fal fa-add"></i>
                  Aggiungi nuovo {{name}}
               </small>
            </button>
         </div>
      </ng-container>

   </mat-autocomplete>

</mat-form-field>
